import axios from "axios";

class TranscriptsApi {
  constructor() {
    this.api = axios.create({
      baseURL: `/api/v1/video-transcripts/`,
      headers: {},
    });
  }

  async getTranscript(type,id) {
    return this.api.get(`${type}/${id}`);
  }
}

export default TranscriptsApi;
